export default function Breadcrumb({ list }) {
  return (
    <div className='flex items-center text-sm text-gray-700'>
      {
        list.slice(0, -1)
          .map(({ name, href }) => (
            <div key={ name } className='flex items-center shrink-0'>
              <div>
                <C.Link href={ href }>{ name }</C.Link>
              </div>
              <div className='px-2'>
                <Icon.ChevronDoubleRight className='w-3 h-3' />
              </div>
            </div>
          ))
      }
      <div className='flex-1 line-clamp-1'>{ list.at(-1).name }</div>
    </div>
  )
}
